export const SIGN_IN_URL = 'https://app.apcplus.xyz/login';
export const REGISTER_URL = 'https://app.apcplus.xyz/register';
export const APP_URL = 'https://app.apcplus.xyz/';
export const PRIVY_SECURITY_URL = 'https://www.privy.io/security';
export const OFFICIAL_SITE_URL = 'https://www.apcplus.xyz';
export const CONTACT_EMAIL = 'info@apcplus.xyz';
